"use strict";

exports.__esModule = true;
var _DeviceTypeListContext = require("./DeviceTypeListContext");
Object.keys(_DeviceTypeListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTypeListContext[key]) return;
  exports[key] = _DeviceTypeListContext[key];
});
var _DeviceTypeListLoader = require("./DeviceTypeListLoader");
Object.keys(_DeviceTypeListLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTypeListLoader[key]) return;
  exports[key] = _DeviceTypeListLoader[key];
});